import {h, Fragment} from "preact"
import { useState, useEffect, useRef } from "preact/hooks";
import Icon from "./Icon";

export default function Select({
    value,
    onChange,
    className,
    options,
    classNameContainer,
    labelTitle,
}) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    
    const handleDropdownToggle = () => setIsOpen(!isOpen);

    
    const handleOptionClick = (optionValue) => {
        onChange({ target: { value: optionValue } });
        setIsOpen(false);
    };

    
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const selectedLabel = options.find((option) => option.value === value)?.label || "";

    return (
        <div ref={dropdownRef} className={`pd-select__dropdown ${classNameContainer}`}>
            <div
                className={`pd-select__dropdown__button ${isOpen ? "pd-select__dropdown--open" : ""}`}
                role="button"
                aria-expanded={isOpen}
                onClick={handleDropdownToggle}
                tabIndex={0}
            >
                <strong>{labelTitle}</strong> {selectedLabel}
                <Icon name="arrow" className="ns-absolute pd-select__arrow" />
            </div>
            {isOpen && (
                <div className="pd-select__dropdown__content">
                    <div className="pd-select__list">
                        {options.map((option) => (
                            <div
                                key={option.value}
                                className={`pd-select__list__option ${
                                    value === option.value ? "pd-select__active" : ""
                                }`}
                                onClick={() => handleOptionClick(option.value)}
                            >
                                {option.label}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
